import request from '@/utils/request'

// 获取合同图片等信息
export function getDraftInfo(data) {
	return request({
		url: '/api/common/v1/task/getDraftInfo',
		method: 'post',
		data
	})
}

// 保存签署位置
export function saveLocation(data) {
	return request({
		url: '/api/common/v1/task/saveLocation',
		method: 'post',
		data
	})
}

// 获取签署详情
export function getSignDetailInfo(data) {
	return request({
		url: '/api/common/v1/task/getSignDetailInfo',
		method: 'post',
		data
	})
}

// 完成签署
export function taskSign(data) {
	return request({
		url: '/api/common/v1/task/sign',
		method: 'post',
		data
	})
}


// 使用短信验证码换取意愿认证token
export function getAuthTokenBySmsVerificationCode(data) {
	return request({
		url: '/api/common/v1/auth/getAuthTokenBySmsVerificationCode',
		method: 'post',
		data
	})
}

// 使用签署密码换取意愿认证token
export function getAuthTokenByPin(data) {
	return request({
		url: '/api/common/v1/auth/getAuthTokenByPin',
		method: 'post',
		data
	})
}

// 校验签署过程中所使用的印章是否需要走审批流程
export function checkSealPermission(data) {
	return request({
		url: '/api/common/v1/task/checkSealPermission',
		method: 'post',
		data
	})
}

// 企业签署提交签署信息及审批信息
export function signWithProcess(data) {
	return request({
		url: '/api/common/v1/task/signWithProcess',
		method: 'post',
		data
	})
}




export function getContractPositionApi(data) {
	return request({
		url: '/contract/position?contractId=' + data.contractId + '&signingBody=' + data.signingBody + '&companyId=' + data.companyId + '&nocache=' + new Date().getTime(),
		method: 'get'
	})
}

export function signSealApi(data) {
	return request({
		url: '/contract/sealSign',
		method: 'post',
		data
	})
}

export function returnContractApi(data) { // 退回合同
	return request({
		url: '/contract/return',
		method: 'post',
		data
	})
}

export function getDatePngSrcApi() {
	return request({
		url: '/common/getDatePngSrc',
		method: 'get'
	})
}

export function getCompanyLegalApi(params) {
	return request({
		url: '/sealInfo/companyLegal',
		method: 'get',
		params
	})
}

export function getRelieveInfo(data) {
	return request({
		url: '/api/common/v1/task/getRelieveInfo',
		method: 'post',
		data
	})
}

export function getSignFileImgArrayRelieve(data) {
	return request({
		url: '/api/common/v1/tool/getSignFileImgArrayRelieve',
		method: 'post',
		data
	})
}

export function saveTaskRelieve(data) {
	return request({
		url: '/api/common/v1/task/saveTaskRelieve',
		method: 'post',
		data
	})
}

export function listProcess(data) {
	return request({
		url: '/api/common/v1/process/listFlow',
		method: 'post',
		data: data
	})
}

export function getProcess(data) {
	return request({
		url: '/api/common/v1/process/getFlow',
		method: 'post',
		data: data
	})
}

// 获取签署任务详情
export function signProcessPosition(data) {
	return request({
		url: '/api/common/v1/task/signProcessPosition',
		method: 'post',
		data
	})
}
